export default class AppContentController {
	constructor($injector, $scope) {
		this.$scope = $scope;
		this.SidebarService = $injector.get('SidebarService');
	}

	$onInit() {
		this.showSidebar = this.SidebarService.isOpen();
		
		this.registerEvents();
	}

	registerEvents() {
		this.$scope.$on('content:toggle', (events, args) => {
			this.showSidebar = this.SidebarService.isOpen();
		});
	}
}
